<div class="row">
  <div class="col-12">
    <div class="pages_space">
      <div class="row mb-2" *ngIf="claimUsecaseName === 'carcinoma-of-the-lung' || claimUsecaseName === 'mesothelioma'">
        <div class="col-12 col-md">
          <!-- search placeholder -->
          <form name="searchMedicalRecordsFilterForm" [formGroup]="searchMedicalRecordsFilterForm" #formDir="ngForm">
            <div class="row search_section">
              <div class="col col-md-6 col-lg-4 col-xl-3 pr-lg-0">
                <input type="text" class="form-control rounded-0" formControlName="keyword" placeholder="Search" />
              </div>
              <div class="col-auto ">
                <div class="k_button_holder">
                  <k-button [type]="KButtonType.KLAiMSButton" [label]="'Search'" [color]="'brand-main'"
                    (buttonClick)="submitSearchMedicalRecordsFilterForm($event, searchMedicalRecordsFilterForm)">
                  </k-button>
                  <k-button [type]="KButtonType.KLAiMSButton" [color]="'brand-main'"
                    [icon]="{type: 'fas', name: 'undo'}"
                    (buttonClick)="resetSearchMedicalRecordsFilterForm(searchMedicalRecordsFilterForm)">
                  </k-button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="row mt-3" *ngIf="claimUsecaseName === 'carcinoma-of-the-lung' || claimUsecaseName === 'mesothelioma'">
        <div class="col-12 col-md">
          <h4>Immunohistochemistry Profiling</h4>
        </div>
        <div class="col-12 col-md-auto mt-2 mt-md-0 text-end">
          <k-button [type]="KButtonType.KLAiMSButton" [label]="'Create New Profile'" [color]="'brand-main'"
            [icon]="{type: 'fas', name: 'plus'}" (buttonClick)="createImmunoProfiles()">
          </k-button>
        </div>
      </div>

      <div class="row" *ngIf="claimUsecaseName === 'carcinoma-of-the-lung' || claimUsecaseName === 'mesothelioma'">
        <div class="col-12 col-md" *ngIf="this.allImmunoProfiles.length == 0">
          <p>No Data found</p>
        </div>
      </div>

      <div class="row mt-3" *ngIf="claimUsecaseName === 'carcinoma-of-the-lung' || claimUsecaseName === 'mesothelioma'">
        <!-- Loop -->
        <div class="col-12 col-lg-6 col-xl-3 iQcard_col" *ngFor="let profile of this.allImmunoProfiles">
          <div class="card iQcard item-hover-effect"  (click)="editProfile($event, profile)">
            <div class="iQcard_header" >
              <div class="row" >
                <div class="col">
                  <div class="headerTitle" title="Employer">{{profile['title']}}</div>
                </div>
                <div class="col-auto pl-0">
                  <ul class="card_more_dropdown float-right">
                    <li>
                      <a>
                        <k-icon class="kebab_menu"
                          [icon]="{type: 'image', src: './../assets/images/more.svg'}"></k-icon>
                      </a>
                      <ul>
                        <li (click)="editProfile($event, profile)">
                          Edit
                        </li>
                        <li *ngIf='isDeleteProfileAllowed'(click)="confirmDeleteProfileModal($event, profile)">
                          Delete
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="iQcard_body pt-0">
              <p class="mb-0" title="Audiogram date">
                {{profile['createdAt'] | date:'dd/MM/yyyy'}}
              </p>
            </div>
          </div>
        </div>
        <!-- Loop End -->
      </div>
      <!-- </div> -->

      <div class="row mt-3">
        <div class="col-12 col-md">
          <h4>Radiological Progression</h4>
        </div>
        <div class="col-12 col-md-auto mt-2 mt-md-0 text-end">
          <k-button [type]="KButtonType.KLAiMSButton" [label]="'Create New Chart'" [color]="'brand-main'"
            [icon]="{type: 'fas', name: 'plus'}" (buttonClick)="createNewChart()">
          </k-button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md" *ngIf="this.allRadiologicalProg.length == 0">
          <p>No Data found</p>
        </div>
      </div>

      <div class="row mt-3">
        <!-- Loop -->
        <div class="col-12 col-lg-6 col-xl-3 iQcard_col" *ngFor="let radProg of this.allRadiologicalProg"  (click)="viewRadiologicalProgression($event, radProg['_id'],radProg['title'])">
          <div class="card iQcard item-hover-effect">
            <div class="iQcard_header">
              <div class="row">
                <div class="col">
                  <div class="headerTitle" title="title">{{radProg['title']}}</div>
                </div>
                <div class="col-auto pl-0">
                  <ul class="card_more_dropdown float-right">
                    <li>
                      <a>
                        <k-icon class="kebab_menu"
                          [icon]="{type: 'image', src: './../assets/images/more.svg'}"></k-icon>
                      </a>
                      <ul>
                        <li (click)="editRadiologicalProgression($event, radProg['_id'])">
                          Edit
                        </li>
                        <li (click)="viewRadiologicalProgression($event, radProg['_id'],radProg['title'])">
                          View
                        </li>
                        <li *ngIf='isDeleteRadProgressionAllowed' (click)="confirmDeleteModalRadiologicalProgression($event, radProg)">
                          Delete
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="iQcard_body pt-0">
              <p class="mb-0" title="radiological progression date">
                Performed on {{radProg['createdAt'] | date: 'dd/MM/YYYY'}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div> 

    <!-- Modal Immunohistological Profile Delete Confirm-->
    <ng-template #confirmDeleteProfile let-modal>
      <div class="modal-header">
        <h5 class="modal-title ">Confirm </h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="px-3">
          <p>Delete Immunohistological Profile taken on {{selectedProfile.createdAt | date:'dd/MM/yyyy'}} ? This cannot
            be undone.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-dark-grey klaim_btn text-center" (click)="modal.close('Cancel click')">
          Cancel</button>
        <button type="button" class="btn-brand-main klaim_btn text-center" (click)="this.deleteImmunoProfile()">
          OK</button>
      </div>
    </ng-template>
    <!-- Modal End  Immunohistological Profile Delete Confirm-->

    <!-- Modal Radiological Progression Delete Confirm-->
    <ng-template #confirmDeleteRadProgression let-modal>
      <div class="modal-header">
        <h5 class="modal-title ">Confirm </h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="px-3">
          <p>Delete Radiological Progression taken on {{selectedRadProg.createdAt | date:'dd/MM/yyyy'}} ? This cannot
            be undone.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-dark-grey klaim_btn text-center" (click)="modal.close('Cancel click')">
          Cancel</button>
        <button type="button" class="btn-brand-main klaim_btn text-center" (click)="this.deleteRadProgression()">
          OK</button>
      </div>
    </ng-template>
    <!-- Modal End  Radiological Progression Delete Confirm-->

    <k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
      [timeout]="timeout"></k-simple-alert>
    <k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText"
      [timeout]="timeout"></k-simple-alert>